<h1 *ngIf="!alliance" class="px-2 mx-auto">Loading...</h1>
<section *ngIf="alliance" class="flex flex-col justify-center mx-auto">
  <h1
    class="px-2 m-2 mb-2 text-center bg-gray-800 border border-gray-800 border-solid"
  >
    <a *ngIf="alliance" [routerLink]="['/alliance', alliance.id]">
      <span [innerHTML]="alliance.name | safeHtml"> </span>
      ({{ alliance.id }})
    </a>
  </h1>
  <div class="flex flex-row flex-wrap max-w-full mx-2">
    <!-- Allgemein -->
    <div class="max-w-sm mt-2 mr-2">
      <div class="grid grid-cols-2 gap-1">
        <div
          class="col-span-2 px-2 bg-gray-800 border border-gray-800 border-solid"
        >
          Präsident
        </div>
        <div
          class="col-span-2 px-2 break-all border border-gray-800 border-solid"
        >
          <a [routerLink]="['/player', alliance.president.id]">
            <span [innerHTML]="alliance.president.name | safeHtml"> </span>
            ({{ alliance.president.id }})
          </a>
        </div>
        <div class="px-2 bg-gray-800 border border-gray-800 border-solid">
          Mitgliederanzahl
        </div>
        <div class="px-2 text-right border border-gray-800 border-solid">
          {{ alliance.members.length }}
        </div>
        <div class="px-2 bg-gray-800 border border-gray-800 border-solid">
          Aktualisiert
        </div>
        <div class="px-2 text-right border border-gray-800 border-solid">
          {{ alliance.updatedAt | date: "dd.MM.yyyy HH:mm" }}
        </div>
        <div class="px-2 bg-gray-800 border border-gray-800 border-solid">
          Erstellt
        </div>
        <div class="px-2 text-right border border-gray-800 border-solid">
          {{ alliance.createdAt | date: "dd.MM.yyyy HH:mm" }}
        </div>
      </div>
      <!-- Allianz-Mitglieder auflisten -->
      <div class="grid max-w-sm grid-cols-1 gap-1 mt-2">
        <div class="px-2 bg-gray-800 border border-gray-800 border-solid">
          Mitglieder
        </div>
        <div
          *ngFor="let player of alliance.members"
          class="px-2 border border-gray-800 border-solid"
        >
          <a [routerLink]="['/player', player.id]">
            <span [innerHTML]="player.name | safeHtml"> </span>
            ({{ player.id }})
          </a>
        </div>
      </div>
    </div>
  </div>
</section>
